// extracted by mini-css-extract-plugin
export default {"noBackground":"Mca-z","qnaContainer":"Nca-z","qna":"Oca-z","question":"Pca-z","modal":"Qca-z"};